module.exports = __webpack_public_path__ + "img/logo-2-light.d8109ead.png";